import { Skeleton } from "@/components/ui/baseUi/skeleton"
import { cn } from "@/modules/lib/utils"

type LoadingBlockProps = {
  className?: string
} & React.ComponentProps<"div">

export function LoadingBlock({ className, ...props }: LoadingBlockProps) {
  return <Skeleton className={cn("rounded-4xl", className)} {...props} />
}
